export const PAYMENT_METHOD_CLEAR_OPERATION = '__clear__';

let paymentMethodBffTreatments: Record<string, boolean> = {};

export const setPaymentMethodBffTreatments = (
    newTreatments: Record<string, boolean>,
) => {
    paymentMethodBffTreatments = newTreatments;
};

export const shouldServePaymentMethodFromBff = (
    paymentMethod: string,
): boolean => {
    return paymentMethodBffTreatments[paymentMethod] ?? false;
};
